import { countTo } from '../functional-helpers.js';

const Sequence = (content) => ({
    astType: 'Sequence',
    content: _processRawContent(_intersperse(content, countTo(content.length - 1).map(() => '\n'))),
});
const ast = (strings, ...content) => _preventToString({
    astType: 'Sequence',
    content: _processRawContent(_intersperse(strings, content)),
});
const _processRawContent = (content) => {
    // 1. Flatten arrays and AstSequence, filter out nulls, and convert numbers to strings
    // Basically converts input to an Array<AstContent>.
    const flattenedAndFiltered = content.flatMap((element) => {
        if (typeof element === 'string') {
            return [element];
        }
        else if (typeof element === 'number') {
            return [element.toString()];
        }
        else {
            if (element === null) {
                return [];
            }
            else if (Array.isArray(element)) {
                return _processRawContent(_intersperse(element, countTo(element.length - 1).map(() => '\n')));
            }
            else if (typeof element === 'object' &&
                element.astType === 'Sequence') {
                return element.content;
            }
            else {
                return [element];
            }
        }
    });
    // 2. Combine adjacent strings
    const [combinedContent, remainingString] = flattenedAndFiltered.reduce(([combinedContent, currentString], element) => {
        if (typeof element === 'string') {
            return [combinedContent, currentString + element];
        }
        else {
            if (currentString.length) {
                return [[...combinedContent, currentString, element], ''];
            }
            else {
                return [[...combinedContent, element], ''];
            }
        }
    }, [[], '']);
    if (remainingString.length) {
        combinedContent.push(remainingString);
    }
    return combinedContent;
};
/**
 * Intersperse content from array1 with content from array2.
 * `array1.length` must be equal to `array2.length + 1`.
 */
const _intersperse = (array1, array2) => {
    if (array1.length === 0) {
        return [];
    }
    return array1.slice(1).reduce((combinedContent, element, i) => {
        return combinedContent.concat([array2[i], element]);
    }, [array1[0]]);
};
/**
 * Prevents AST elements from being rendered as a string, as this is
 * most likely an error due to unproper use of `ast`.
 * Deacivated. Activate for debugging by uncommenting the line below.
 */
const _preventToString = (element) => ({
    ...element,
    // Uncomment this to activate
    // toString: () => { throw new Error(`Rendering element ${elemennt.astType} as string is probably an error`) }
});

export { Sequence, _processRawContent, ast };
